import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularUiCommonModule } from '../angular-ui-common.module';
import { TranslateModule } from '@ngx-translate/core';
import { SetOrResetPasswordComponent } from './set-or-reset-password/set-or-reset-password/set-or-reset-password.component';
import { LoginComponent } from './login/login.component';
import { SetOrResetPasswordStep1Component } from './set-or-reset-password/set-or-reset-password-step1/set-or-reset-password-step1.component';
import { SetOrResetPasswordStep2Component } from './set-or-reset-password/set-or-reset-password-step2/set-or-reset-password-step2.component';
import { ChangePasswordDialogComponent } from './change-password/change-password-dialog/change-password-dialog.component';
import { ChangePasswordComponent } from './change-password/change-password/change-password.component';
import { VerifyContactDialogComponent } from './verify-contact/verify-contact-dialog/verify-contact-dialog.component';
import { VerifyContactComponent } from './verify-contact/verify-contact/verify-contact.component';
import { SignUpStep1Component } from './sign-up/sign-up-step1/sign-up-step1.component';
import { SignUpStep2Component } from './sign-up/sign-up-step2/sign-up-step2.component';
import { SignUpComponent } from './sign-up/sign-up.component';

@NgModule({
  declarations: [
    LoginComponent, 
    SetOrResetPasswordStep1Component,
    SetOrResetPasswordStep2Component,
    SetOrResetPasswordComponent,
    SignUpStep1Component,
    SignUpStep2Component,
    SignUpComponent,
    ChangePasswordComponent,
    ChangePasswordDialogComponent,
    VerifyContactComponent,
    VerifyContactDialogComponent
  ],
  imports: [
    CommonModule,
    AngularUiCommonModule,
    // i18n
    TranslateModule,
  ],
  entryComponents: [ 
    ChangePasswordDialogComponent,
    VerifyContactDialogComponent
  ],
  exports: [
    LoginComponent
  ]
})
export class SecurityUiModule { }
